import { shouldBump, type GenerationState } from './policy';
import {
  countEligible,
  countExhaustedVotes,
  OBSERVER_TTL_MS,
  type ObserverRegistry,
} from './registry';

// VX-4302: the single "commit a bump right now?" decision. Composes the TTL'd registry counts with
// the conservative policy, always evaluated against the CURRENT generation so votes cast against an
// already-superseded generation can never trigger a fresh bump. Pure — no Recoil/React.

export interface EvaluateBumpInput {
  generationState: GenerationState;
  registry: ObserverRegistry;
  now: number;
  ttlMs?: number;
}

export function evaluateBump({
  generationState,
  registry,
  now,
  ttlMs = OBSERVER_TTL_MS,
}: EvaluateBumpInput): boolean {
  const eligibleCount = countEligible(registry, now, ttlMs);
  const exhaustedVotes = countExhaustedVotes(registry, generationState.generation, now, ttlMs);
  return shouldBump({ eligibleCount, exhaustedVotes, state: generationState, now });
}
